/**
 * @generated SignedSource<<05327c4554c3a47ec9432fe23df95a90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetIpoolIntegration_widgetIntegrationIpool$data = {
  readonly id: string;
  readonly integration: {
    readonly employeesWithShifts: ReadonlyArray<{
      readonly id: string;
      readonly shifts: ReadonlyArray<{
        readonly endAt: string;
        readonly id: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee" | "WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee">;
    }>;
  };
  readonly overviewSize: WidgetOverviewSize;
  readonly " $fragmentType": "WidgetIpoolIntegration_widgetIntegrationIpool";
};
export type WidgetIpoolIntegration_widgetIntegrationIpool$key = {
  readonly " $data"?: WidgetIpoolIntegration_widgetIntegrationIpool$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegration_widgetIntegrationIpool">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIpoolIntegration_widgetIntegrationIpool",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overviewSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationIpool",
      "kind": "LinkedField",
      "name": "integration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationIpoolEmployee",
          "kind": "LinkedField",
          "name": "employeesWithShifts",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationIpoolShift",
              "kind": "LinkedField",
              "name": "shifts",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetIntegrationIpool",
  "abstractKey": null
};
})();

(node as any).hash = "c120dca51a7a6135a5501adee94fee55";

export default node;
